import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import history from '../history';
import { RulesList } from './action-types';
import { showFeedbackError } from './ui';

const list = createAsyncThunk(RulesList.LIST_RULES, async (
  arg,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  const decisionDefinitions: CMxAPI.DecisionDefinitionDto[] = await api<
    CMxAPI.DecisionDefinitionDto[]
  >({
    endpoint: '/rules/list/v1'
  });

  return decisionDefinitions;
});

const getXML = createAsyncThunk(RulesList.GET_XML, async (
  decision,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  const { taskId, decisionKey } = decision;

  const fileObject: CMxAPI.DecisionModelDto = await api<any>({
    endpoint: `/rules/${taskId}/v1`
  }).catch(e => {
    dispatch(
      showFeedbackError({
        id: Date.now(),
        message: `Decision Definition Not Found`,
        dismissable: true
      })
    );
    throw e;
  });

  history.push(`/cmx/admin/rules/${decisionKey}/`);
  return fileObject.file;
});

export { list, getXML };
